import script from "./USavePhotoDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./USavePhotoDialog.vue?vue&type=script&setup=true&lang=ts"

import "./USavePhotoDialog.vue?vue&type=style&index=0&id=3e5810da&lang=css"

const __exports__ = script;

export default __exports__